import { useEffect, useMemo, useRef, useState } from "react";
import { QueueCall, subscribeToCalls } from "../../services/queueService";
import "./Painel.css";

const PainelTVScreen = () => {
  const userId = new URLSearchParams(window.location.search).get("uid") ?? "";
  const [calls, setCalls] = useState<QueueCall[]>([]);
  const [animateKey, setAnimateKey] = useState(0);
  const lastCallIdRef = useRef<string | null>(null);

  const speakCall = (display: string, deskId: string) => {
    if (!window.speechSynthesis) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(`Senha ${display}`);
    utterance.lang = "pt-BR";
    utterance.rate = 0.9;
    utterance.pitch = 1;
    window.speechSynthesis.speak(utterance);
  };

  useEffect(() => {
    if (!userId) return;
    const unsubscribe = subscribeToCalls(12, userId, (data) => {
      setCalls(data);
      const currentId = data[0]?.id || null;
      if (currentId && currentId !== lastCallIdRef.current) {
        lastCallIdRef.current = currentId;
        setAnimateKey((prev) => prev + 1);
        speakCall(data[0].display, data[0].deskId);
      }
    });
    return () => unsubscribe();
  }, [userId]);

  const lastCall = useMemo(() => calls[0], [calls]);
  const history = useMemo(() => calls.slice(1, 5), [calls]);

  return (
    <div className="painel-tv-screen">
      <header className="painel-tv-header">
        <div>
          <h1>Painel de Chamadas</h1>
          <p>Atendimento presencial</p>
        </div>
        <div className="painel-tv-clock">
          {new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
        </div>
      </header>

      <section className="painel-tv-main">
        <div key={`now-${animateKey}`} className="painel-tv-now painel-animate">
          <span>Senha chamada</span>
          <strong>{lastCall ? lastCall.display : "---"}</strong>
        </div>
        <div key={`desk-${animateKey}`} className="painel-tv-desk painel-animate">
          <span>Guichê</span>
          <strong className="text-uppercase">{lastCall ? lastCall.deskId : "---"}</strong>
        </div>
      </section>

      <section className="painel-tv-history">
        <h2>Últimas chamadas</h2>
        {history.length === 0 ? (
          <p>Nenhuma chamada registrada.</p>
        ) : (
          <div className="painel-tv-history-grid">
            {history.map((call) => (
              <div key={call.id} className="painel-tv-history-item">
                <span>{call.display}</span>
                <strong className="text-uppercase">{call.deskId}</strong>
              </div>
            ))}
          </div>
        )}
      </section>
    </div>
  );
};

export default PainelTVScreen;
